import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-display-column-dialog',
  templateUrl: './display-column-dialog.component.html',
  styleUrls: ['./display-column-dialog.component.scss'],
})
export class DisplayColumnDialogComponent {
  form!: FormGroup;
  columnsToDisplay: any[] = [];
  applyCss: boolean = false;
  isPdfDisabled: boolean = false;

  constructor(
    private dialogRef: MatDialogRef<DisplayColumnDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    private snackBar: ToastrService,
  ) {
    this.columnsToDisplay = this.data.columns || [];
    this.form = this.fb.group({
      columns: this.fb.array([]),
    });
  }

  ngOnInit() {
    const formArray = this.columnsToDisplay.map(() => this.fb.control(false));
    this.form.setControl('columns', this.fb.array(formArray));

    this.columns.valueChanges.subscribe(() => {
      this.checkPdfValidity();
    });
  }

  get columns(): FormArray {
    return this.form.get('columns') as FormArray;
  }

  onClose() {
    this.dialogRef.close();
  }
  allSelected(): boolean {
    return this.columns.controls.every((control) => control.value === true);
  }

  toggleAll(event: any) {
    const checked = event.checked;
    this.columns.controls.forEach((control) => control.setValue(checked));
  }
  isApplyCss(): boolean {
    return this.applyCss;
  }

  toggleApplyCss(event: any) {
    this.applyCss = event.checked;
  }

  getColumnsWithSelection(): {
    label: string;
    field: string;
    selected: boolean;
  }[] {
    return this.columns.controls.map((control, i) => ({
      label: this.columnsToDisplay[i].label,
      field: this.columnsToDisplay[i].field,
      selected: control.value,
    }));
  }

  exportData(type: string) {
    if (!this.columns.controls.some((control) => control.value === true)) {
      this.snackBar.error('Please select at least one column');
      return;
    }

    const selectedColumns = this.getColumnsWithSelection().filter(
      (col) => col.selected,
    );

    if (type === 'pdf' && this.data.pdfExportService) {
      const validation =
        this.data.pdfExportService.validatePdfColumns(selectedColumns);
      if (!validation.valid) {
        this.snackBar.error(validation.message);
        return;
      }
    }

    this.dialogRef.close({
      exportType: type,
      columns: this.getColumnsWithSelection(),
      applyCss: this.applyCss,
    });
  }

  checkPdfValidity() {
    const selectedColumns = this.getColumnsWithSelection().filter(
      (col) => col.selected,
    );
    if (selectedColumns.length === 0) {
      this.isPdfDisabled = false;
      return;
    }

    if (this.data.pdfExportService) {
      const validation =
        this.data.pdfExportService.validatePdfColumns(selectedColumns);
      this.isPdfDisabled = !validation.valid;
    }
  }
}
